import { useMutation } from '@apollo/client';
import mutation from 'client/mutations/createOrder';

export default function useCreateOrder() {
  return useMutation(mutation);
}
